export enum SanitizeType {
    html = 'html',
    style = 'style',
    script = 'script',
    url = 'url',
    resourceUrl = 'resourceUrl'
}

export interface ConfirmationDialogSettings {
    message: string;
    action: string;
    title: string;
    needCancel?: boolean;
    cancelText?: string;
    type?: SanitizeType;
    panelClass?: string | string[];
    needExtraPadding?: boolean;
    addtlData?: unknown;
    autoFocus?: boolean;
    disableClose?: boolean;
    needCross?: boolean;
    dataQaId?: string;
}

export const InitCancelConfirmationDialogSettings = (
    confirmationDialogSettings?: Partial<ConfirmationDialogSettings>
): ConfirmationDialogSettings => {
    const defaults: ConfirmationDialogSettings = {
        title: 'Are you sure?',
        message: 'Your changes will be discarded if you continue.',
        action: 'YES, DISCARD CHANGES',
        needCancel: true,
        cancelText: 'Cancel',
        disableClose: false,
    };

    return {
        ...defaults,
        ...confirmationDialogSettings
    };
};

export const InitCloseConfirmationDialogSettings = (
    confirmationDialogSettings?: Partial<ConfirmationDialogSettings>
): ConfirmationDialogSettings => {
    const defaults: ConfirmationDialogSettings = {
        title: 'Unsaved Changes',
        message: 'You have unsaved changes on this page. Are you sure you want to leave the view and discard your changes?',
        action: 'GO BACK AND SAVE',
        needCancel: true,
        cancelText: 'DISCARD CHANGES',
        disableClose: false
    };

    return {
        ...defaults,
        ...confirmationDialogSettings
    };
};

